import { Outlet } from "react-router-dom";
import NavBar from "../blog/components/NavBar";

export default function BlogLayout() {
  return (
    <div className="blog-layout flex flex-col">
      <NavBar />
      <Outlet/>
    </div>
  );
}
